import script from "./orderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./orderForm.vue?vue&type=script&setup=true&lang=js"

import "./orderForm.vue?vue&type=style&index=0&id=1cedfdea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cedfdea"]])

export default __exports__